
export function ExpandableRowHeader({ title }: { title: string; }) {
    return (
        <h2 className="font-semibold mb-2 dark:text-stone-100">{title}</h2>
    )
}